import {Component} from '@angular/core';
import { navItems } from '../../_nav';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent {
  public sidebarMinimized = false;
  public navItems = navItems;
 constructor( private authenticationService: AuthService,private router: Router) {}
  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }
    
    logout() {
 
         this.authenticationService.logout();
         this.router.navigate(['/login']);
     }
}
